const Lights = ({
    ambientLightIntensity = 1.2,
    directionalLightIntensity = 1.5,
    shadowMapSize = [1024, 1024],
    shadowCameraLeft = -10,
    shadowCameraRight = 10,
    shadowCameraTop = 10,
    shadowCameraBottom = -10,
    shadowCameraFar = 10,
    shadowCameraNear = 1,
}) => (
    <>
        <directionalLight
            castShadow
            position={[0, 10, 0]}
            intensity={directionalLightIntensity}
            shadow-mapSize={shadowMapSize}
            shadow-camera-left={shadowCameraLeft}
            shadow-camera-right={shadowCameraRight}
            shadow-camera-top={shadowCameraTop}
            shadow-camera-bottom={shadowCameraBottom}
            shadow-camera-far={shadowCameraFar}
            shadow-camera-near={shadowCameraNear}
        />
        <ambientLight intensity={ambientLightIntensity} />
    </>
);

export default Lights;
